"use client"
import Spinner from "../../spinner"
import Modal from "../../shared-modules/Modal"

const StatusModal = ({ isOpen, onClose, title, message, status, isLoading }) => {
  const statusContent = (
    <div
      className="modal-body"
      style={{
        textAlign: "center",
        padding: "10px 0 20px",
      }}
    >
      {isLoading ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "15px" }}>
          <Spinner />
          <p>{message || "Processing..."}</p>
        </div>
      ) : (
        <>
          <div
            style={{
              marginBottom: "15px",
              color: status === "success" ? "#4CAF50" : status === "error" ? "#F44336" : "#00134c",
            }}
          >
            {status === "success" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            ) : status === "error" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            ) : null}
          </div>
          <p>{message}</p>
        </>
      )}
    </div>
  )

  return (
    <Modal 
      title={title} 
      isOpen={isOpen} 
      onClose={onClose}
     width="600px"
    >
      {statusContent}
    </Modal>
  )
}

export default StatusModal
